import React from 'react';
import Input from '../../Input';

const ContactInfoStep = ({ formData, onChange, onEmailBlur, errors }) => {
  return (
    <div className="space-y-4">
      {/* First Name + Last Name */}
      <div className="grid grid-cols-2 gap-3">
        <Input
          label="First Name"
          name="userFirstName"
          value={formData.userFirstName}
          onChange={onChange}
          required
          error={errors.userFirstName}
          placeholder="First name"
        />
        <Input
          label="Last Name"
          name="userLastName"
          value={formData.userLastName}
          onChange={onChange}
          required
          error={errors.userLastName}
          placeholder="Last name"
        />
      </div>

      <Input
        label="Organization Domain"
        name="userDomain"
        value={formData.userDomain}
        onChange={onChange}
        required
        error={errors.userDomain}
        placeholder="yourcompany.com"
      />

      <Input
        label="Work Email"
        name="userEmail"
        type="email"
        value={formData.userEmail}
        onChange={onChange}
        onBlur={onEmailBlur}
        required
        error={errors.userEmail}
        placeholder="you@yourcompany.com"
      />

      <Input
        label="Phone Number"
        name="organizationContactNo1"
        type="tel"
        value={formData.organizationContactNo1}
        onChange={onChange}
        required
        error={errors.organizationContactNo1}
        placeholder="+1 (555) 000-0000"
      />

      <p className="text-[13px] text-[#6e6e73]">
        We'll send account verification and updates to your work email.
      </p>
    </div>
  );
};

export default ContactInfoStep;
